export default "__VITE_ASSET__b2a52c8d__"